// https://scotch.io/tutorials/handling-authentication-in-vue-using-vuex
import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/_store";
import { apiService } from "@/_services";
// Adds a loading bar at the top during page loads.
import NProgress from "nprogress/nprogress";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  // base: "/app/",

  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [
    {
      path: "*",
      component: () => import(/* webpackChunkName: "404" */ "@/views/404.vue")
    },
    {
      path: "/",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "@/views/login.vue"),
      meta: {
        beforeResolve(routeTo, routeFrom, next) {
          if (store.getters["authentication/loggedIn"]) {
            next({ name: "home" });
          } else {
            next();
          }
        }
      }
    },
    {
      path: "/home/",
      name: "home",
      component: () => import(/* webpackChunkName: "home" */ "@/views/home.vue")
    },
    {
      path: "/account/",
      name: "account",
      component: () =>
        import(/* webpackChunkName: "account" */ "@/views/account.vue")
    }
  ]
});

router.beforeEach((routeTo, routeFrom, next) => {
  // console.log("beforeEach on router.js");
  // If this isn't an initial page load...
  if (routeFrom.name !== null) {
    // Start the route progress bar.
    NProgress.start();
  }

  const authRequired = routeTo.name != "login" ? true : false;

  const loggedIn = store.getters["authentication/loggedIn"];

  // if (loggedIn && !store.state.authentication.verified) {
  //   console.log("Should be verified");
  //   store.dispatch("authentication/validate");
  //   return;
  // }

  // if (authRequired && !loggedIn) {
  //   return next("/login/");
  // }

  // if (!authRequired && loggedIn) {
  //   return next("/home/");
  // }

  // next();

  if (authRequired && !loggedIn) {
    // let authentication = JSON.parse(localStorage.getItem("authentication"));
    // if (authentication && authentication.hasOwnProperty("token")) {
    //   store.dispatch("authentication/validate");
    // }
    apiService.auth
      .validate()
      .then(() => {
        // console.log("GOOD");
        store.dispatch("authentication/setAccount");
        next();
      })
      .catch(() => {
        // console.log("BAD");
        store.dispatch("authentication/unsetAccount");
        next("/");
      });
  } else {
    next();
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              if (routeFrom.name === args[0].name) {
                // Complete the animation of the route progress bar.
                NProgress.done();
              }
              // Complete the redirect.
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }

  // If we reach this point, continue resolving the route.
  next();
});

// When each route is finished evaluating...
router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
